import * as TabsPrimitive from '@radix-ui/react-tabs';
import * as React from 'react';

import { cn } from '@/utils/style';

function Tabs({ onValueChange, ...props }: React.ComponentProps<typeof TabsPrimitive.Root>) {
  const handleValueChange = React.useCallback(
    (value: string) => {
      document.querySelector('main')?.scrollTo({ top: 0 });
      onValueChange?.(value);
    },
    [onValueChange]
  );

  return <TabsPrimitive.Root data-slot="tabs" onValueChange={handleValueChange} {...props} />;
}

function TabsList({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List> & { variant?: TabsTriggerVariant }) {
  const { variant = 'default' } = props;

  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn(
        'bg-muted text-muted-foreground inline-flex w-fit items-center justify-center m-[3px] flex-wrap border border-gray-200 rounded overflow-hidden bg-gray-200 gap-px',
        {
          'bg-transparent border-0': variant === 'minimal',
        },
        className
      )}
      {...props}
    />
  );
}

type TabsTriggerVariant = 'default' | 'minimal';

function TabsTrigger({
  className,
  variant,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger> & { variant?: TabsTriggerVariant }) {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        "bg-white data-[state=active]:bg-gray-50 dark:data-[state=active]:text-foreground focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:outline-ring dark:data-[state=active]:border-input dark:data-[state=active]:bg-input/30 text-foreground dark:text-muted-foreground inline-flex h-[calc(100%-1px)] flex-1 items-center justify-center gap-1.5 data-[state=active]:border-b-gray-900 data-[state=active]:border-b px-2 py-1 text-sm font-medium whitespace-nowrap focus-visible:ring-[3px] focus-visible:outline-1 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
        {
          'bg-transparent text-gray-700 border-x-0 border-t-0 border-b border-gray-200 data-[state=active]:text-pink-700! data-[state=active]:border-b-pink-700':
            variant === 'minimal',
        },
        className
      )}
      {...props}
    />
  );
}

function TabsContent({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      data-slot="tabs-content"
      className={cn('flex-1 outline-none', className)}
      {...props}
    />
  );
}

export { Tabs, TabsContent, TabsList, TabsTrigger };
